import { gql } from '@apollo/client';

export const CREATE_NOTIFICATION = gql`
  mutation createNotification($input: CreateNotificationInput!) {
    createNotification(createNotificationInput: $input) {
      id
    }
  }
`;
